import useMediaQuery, { maxWidthQueries, minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled, { useTheme } from 'styled-components'

const PageWrapper = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(/images/starSystem/background_shoi_void_page.png);
`

const TextDiv = styled.div`
  overflow: auto;
  max-width: 100%;
  min-height: 100vh;
  color: WhiteSmoke;
  overflow-wrap: break-word;
  overflow: hidden;
  a {
    color: rgb(163, 206, 230);
  }
  @media ${minWidthQueries.md} {
    width: 40vw;

    font-size: 2em;
    padding-top: 8rem;
    display: flex;
    flex-direction: column;
  }
  @media ${minWidthQueries.ms} {
    padding-top: 5rem;
    font-size: 1.1em;
  }
`

const GlassBox = styled.div`
  overflow: auto;
  min-height: 100vh;
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  border-radius: 15px;
  background: rgba(170, 170, 170, 0.3);
  box-shadow: inset 2px 5px 5px 5px black;
`

const GlassWrapper = ({ children }) => {
  return (
    <PageWrapper>
      <GlassBox>
        <TextDiv>{children}</TextDiv>
      </GlassBox>
    </PageWrapper>
  )
}

export default GlassWrapper
